import usePrivateLink from "../../config/usePrivateLink";
import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { student, UpdateStudentDiscount } from "../../../api/StudentServices";
import { getRteStudent } from "../../../api/RteService";
import { closeModal, ToastMain, SweetAlertShow } from "../../master/Master";
import { BusRoute, BusStudentCreate, GetBus } from "../../../api/BusService";
import { imgBaseUrl } from "../../../api/api";
import {
  getDetails,
  studentMonthTransactionDelete,
  UpdateStudentDiscountHostel,
  UpdateStudentDiscountHostel2,
} from "../../../api/HostelService";

const CourseNFeeTab = ({ data, getStudent }) => {
  const hasAccess = usePrivateLink();
  const { id } = useParams();
  const navigate = useNavigate();

  const [Teachers, setTeachers] = React.useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState("");
  const [modalData, setModalData] = useState("");
  const [routes, setRoutes] = useState([]);
  const [buses, setBuses] = useState([]);
  const [searchBusId, setsearchBusId] = useState("");
  const [selectedRouteId, setSelectedRouteId] = useState("");
  const [busFees, setBusFees] = useState("");
  const [busFinalFees, setBusFinalFees] = useState("");
  const [busDiscount, setBusDiscount] = useState("");
  const [SelectedBusId, setSelectedBusId] = useState("");
  const [batchId, setBatchId] = useState(null);
  const studentId = data?.student?.id;
  const [remark, setRemark] = useState("");

  const totalHostelFee = data?.data?.hostel_fees?.reduce(
    (sum, fee) => sum + Number(fee?.final_amount || 0),
    0,
  );

  const updateDicount = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const formData = new FormData(e.target);
      const response = await UpdateStudentDiscountHostel(formData);

      if (response?.data?.status) {
        setError("");
        getStudent();
        // getRteStudent(data?.id);

        ToastMain.fire({
          icon: "success",
          title: "Updated Successfully!",
        });

        e.target.reset();
        setModalData(null);
      } else {
        setError(response?.data?.errors || {});

        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      setError(err?.response?.data?.errors || {});

      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const updateDicount2 = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const formData = new FormData(e.target);
      const response = await UpdateStudentDiscountHostel2(formData);

      if (response?.data?.status) {
        setError("");
        getStudent();
        // getRteStudent(data?.id);

        ToastMain.fire({
          icon: "success",
          title: "Updated Successfully!",
        });

        e.target.reset();
        setModalData(null);
      } else {
        setError(response?.data?.errors || {});

        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      setError(err?.response?.data?.errors || {});

      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Remove Fee Record?",
      text: "This fee record will be removed from the student's hostel fee history.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Remove It",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) return;

    try {
      const res = await studentMonthTransactionDelete({ id });

      if (res.data.status) {
        Swal.fire("Removed!", res.data.message, "success");

        getStudent();
      } else {
        Swal.fire("Error", res.data.message, "error");
      }
    } catch (error) {
      console.log(error);

      Swal.fire("Error", "Something went wrong", "error");
    }
  };

  return (
    <>
      <div className="course-fee-tab">
        {/* =========================================================
            HOSTEL FEE RECORDS ONLY
            Hostel / Room / Bed / Joining Date are already shown
            in StudentProfile2, so they are intentionally removed here.
        ========================================================== */}

        <div className="card hostel-record-card">
          {/* Header */}
          <div className="card-header hostel-record-header">
            <div className="d-flex align-items-center gap-3">
              <div className="hostel-section-icon">
                <i className="ri-money-rupee-circle-line"></i>
              </div>

              <div>
                <h5 className="mb-1">Hostel Fee Records</h5>

                <p className="text-muted small mb-0">
                  Monthly hostel fee collection and payment history
                </p>
              </div>
            </div>

            {/* Keep only record total here.
                Overall fee details are already shown above. */}
            <div className="fee-record-total">
              <span>Total Records</span>
              <strong>{data?.data?.hostel_fees?.length || 0}</strong>
            </div>
          </div>

          <div className="card-body p-3">
            <div className="table-responsive hostel-table-wrapper">
              <table className="table hostel-fee-table align-middle mb-0">
                <thead>
                  <tr>
                    <th className="text-center" style={{ width: "55px" }}>
                      #
                    </th>

                    <th>Month</th>

                    <th>Total Amount</th>

                    <th>Final Amount</th>

                    <th>Paid</th>

                    <th>Remaining</th>

                    <th className="text-center" style={{ width: "150px" }}>
                      Action
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {data?.data?.hostel_fees?.length > 0 ? (
                    data?.data?.hostel_fees?.map((fee, index) => (
                      <tr key={fee.id}>
                        {/* =================================================
                              NUMBER
                          ================================================== */}
                        <td className="text-center">
                          <span className="hostel-row-number">{index + 1}</span>
                        </td>

                        {/* =================================================
                              MONTH
                          ================================================== */}
                        <td>
                          <div className="month-info">
                            <div className="month-icon">
                              <i className="ri-calendar-event-line"></i>
                            </div>

                            <div>
                              <span className="month-title">
                                {data?.data?.fee_type?.toLowerCase() === "full"
                                  ? "Full"
                                  : fee.month}
                              </span>

                              {fee.discount_remark && (
                                <small className="text-muted d-block mt-1">
                                  Discount applied
                                </small>
                              )}
                            </div>
                          </div>
                        </td>

                        {/* =================================================
                              TOTAL AMOUNT
                          ================================================== */}
                        <td>
                          <span className="amount-text">
                            ₹{fee.total_amount}
                          </span>
                        </td>

                        {/* =================================================
                              FINAL AMOUNT
                          ================================================== */}
                        <td>
                          <div className="final-fee-cell">
                            <span className="final-fee-amount">
                              ₹{fee.final_amount}
                            </span>

                            {hasAccess("/student/course/discount") && (
                              <div className="fee-inline-actions">
                                {/* Edit */}
                                {fee.paid_amount == 0 && (
                                  <button
                                    type="button"
                                    className="fee-icon-btn edit"
                                    title="Edit Fee"
                                    onClick={() => {
                                      setModalData(fee);
                                    }}
                                  >
                                    <i className="ri-pencil-line"></i>
                                  </button>
                                )}

                                {/* Remark */}
                                {fee.discount_remark && (
                                  <button
                                    type="button"
                                    className="fee-icon-btn remark"
                                    title="View Discount Remark"
                                    data-bs-toggle="modal"
                                    data-bs-target="#remarkModal"
                                    onClick={() =>
                                      setRemark(fee.discount_remark)
                                    }
                                  >
                                    <i className="ri-chat-3-fill"></i>
                                  </button>
                                )}
                              </div>
                            )}
                          </div>
                        </td>

                        {/* =================================================
                              PAID
                          ================================================== */}
                        <td>
                          <span className="paid-amount">
                            ₹{Number(fee.paid_amount)?.toFixed(2)}
                          </span>
                        </td>

                        {/* =================================================
                              REMAINING
                          ================================================== */}
                        <td>
                          {Number(fee.left_amount) > 0 ? (
                            <div className="remaining-fee">
                              <span className="remaining-dot"></span>₹
                              {Number(fee.left_amount)?.toFixed(2)}
                            </div>
                          ) : (
                            <span className="paid-status">
                              <i className="ri-checkbox-circle-fill"></i>
                              Paid
                            </span>
                          )}
                        </td>

                        {/* =================================================
                              ACTION
                          ================================================== */}
                        <td>
                          <div className="fee-action-group">
                            {/* PAY */}
                            {Number(fee.left_amount) > 0 ? (
                              hasAccess("/hostel/student/fee/pay") && (
                                <Link
                                  to={`/student/fees/deposit?id=${data?.data?.id}&${data?.data?.student_id
                                    ? `student_id=${data.data.student_id}`
                                    : `hostel_student_id=${data?.data?.id}`
                                    }`}
                                  className="btn btn-primary btn-sm fee-pay-btn"
                                >
                                  <i className="ri-wallet-3-line me-1"></i>
                                  Pay
                                </Link>
                              )
                            ) : (
                              <span className="paid-action">
                                <i className="ri-check-double-line"></i>
                                Paid
                              </span>
                            )}

                            {/* DELETE
                                  Same functionality as before.
                                  Only icon/UI is changed. */}
                            {Number(fee.paid_amount) === 0 &&
                              hasAccess(
                                "/hostel/student/fee/record/delete",
                              ) && (
                                <button
                                  type="button"
                                  className="fee-delete-btn"
                                  title="Remove Fee Record"
                                  aria-label="Remove Fee Record"
                                  onClick={() => handleDelete(fee.id)}
                                >
                                  <i className="ri-delete-bin-line"></i>
                                </button>
                              )}
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7">
                        <div className="empty-fee-state">
                          <div className="empty-fee-icon">
                            <i className="ri-file-list-3-line"></i>
                          </div>

                          <h6>No Hostel Fee Records</h6>

                          <p>
                            No monthly hostel fee records are available for this
                            student.
                          </p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>


            </div>

            <div className="fee-record-total d-flex justify-content-between align-items-center border-top mt-3 pt-3 px-2">
              <span className="fw-semibold">
                <i className="ri-wallet-3-line me-2 text-success"></i>
                Advance Fees
              </span>

              <strong className="text-success fs-5">
                ₹{Number(data?.data?.advance_fee || 0).toLocaleString("en-IN")}
              </strong>
            </div>
          </div>
        </div>

        {/* =========================================================
            MONTH FEE DISCOUNT MODAL
            FUNCTIONALITY UNCHANGED
        ========================================================== */}

        {modalData && (
          <Modal
            show={true}
            onHide={() => setModalData(null)}
            centered
            size="lg"
          >
            <Modal.Header closeButton className="hostel-modal-header">
              <div>
                <Modal.Title>
                  <i className="ri-percent-line me-2 text-primary"></i>
                  Hostel Month Fees Discount Change
                </Modal.Title>

                <small className="text-muted">
                  Update the final fee for this hostel fee record
                </small>
              </div>
            </Modal.Header>

            <form onSubmit={updateDicount}>
              <Modal.Body>
                <div className="hostel-modal-alert">
                  <div className="hostel-modal-alert-icon">
                    <i className="ri-information-line"></i>
                  </div>

                  <div>
                    <strong>Important</strong>

                    <p className="mb-0">
                      Changing the hostel month fees discount will affect the
                      student's billing and records. Please ensure the
                      information provided is accurate and authorized.
                    </p>
                  </div>
                </div>

                <input type="hidden" name="id" value={modalData?.id || ""} />

                <div className="row g-3 mt-1">
                  <div className="col-md-6">
                    <div className="hostel-modal-info-box">
                      <span>Total Hostel Fees</span>

                      <strong>₹{data?.data?.hostel_fee || "-"}</strong>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="hostel-modal-info-box">
                      <span>Current Final Fee</span>

                      <strong className="text-success">
                        ₹{modalData?.final_amount || "-"}
                      </strong>
                    </div>
                  </div>
                </div>

                <div className="mt-4 form-floating form-floating-outline">
                  <input
                    type="text"
                    name="fees"
                    className="form-control"
                    required
                    defaultValue={modalData?.final_amount}
                  />

                  <label>Final Fee (₹)</label>

                  <span className="text-danger small">
                    {error?.final_fees ?? ""}
                  </span>
                </div>

                <input
                  type="hidden"
                  name="month"
                  value={modalData?.month || ""}
                />

                <div className="mt-4 form-floating form-floating-outline">
                  <textarea
                    name="discount_remark"
                    className="form-control input-uppercase hostel-remark-textarea"
                    value={modalData?.discount_remark || ""}
                    onChange={(e) =>
                      setModalData({
                        ...modalData,
                        discount_remark: e.target.value,
                      })
                    }
                    required
                  />

                  <label>Discount Remark</label>

                  <span className="text-danger small">
                    {error?.discount_remark ?? ""}
                  </span>
                </div>
              </Modal.Body>

              <Modal.Footer className="hostel-modal-footer">
                <Button
                  variant="light"
                  size="sm"
                  onClick={() => setModalData(null)}
                >
                  Cancel
                </Button>

                <Button
                  type="submit"
                  variant="primary"
                  size="sm"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>{" "}
                      Submitting...
                    </>
                  ) : (
                    <>
                      <i className="ri-save-line me-1"></i>
                      Save Changes
                    </>
                  )}
                </Button>
              </Modal.Footer>
            </form>
          </Modal>
        )}

        {/* =========================================================
            TOTAL HOSTEL FEE DISCOUNT MODAL
            FUNCTIONALITY UNCHANGED
        ========================================================== */}

        {modalData?.default === "2" && (
          <Modal
            show={true}
            onHide={() => setModalData(null)}
            centered
            size="lg"
          >
            <Modal.Header closeButton className="hostel-modal-header">
              <div>
                <Modal.Title>
                  <i className="ri-money-rupee-circle-line me-2 text-primary"></i>
                  Hostel Fees Discount Change
                </Modal.Title>

                <small className="text-muted">
                  Update the student's overall hostel fee
                </small>
              </div>
            </Modal.Header>

            <form onSubmit={updateDicount2}>
              <Modal.Body>
                <div className="hostel-modal-alert">
                  <div className="hostel-modal-alert-icon">
                    <i className="ri-information-line"></i>
                  </div>

                  <div>
                    <strong>Important</strong>

                    <p className="mb-0">
                      Changing the hostel fees discount will affect the
                      student's billing and records. Please ensure the
                      information provided is accurate and authorized.
                    </p>
                  </div>
                </div>

                <input type="hidden" name="id" value={data?.data?.id} />

                <div className="hostel-current-fee-box mt-3">
                  <div>
                    <span>Current Final Fee</span>

                    <strong>₹{data?.data?.final_fee || "-"}</strong>
                  </div>

                  <i className="ri-arrow-right-line"></i>

                  <div>
                    <span>Fee Type</span>

                    <strong>{data?.data?.fee_type || "-"}</strong>
                  </div>
                </div>

                <div className="mt-4 form-floating form-floating-outline">
                  <input
                    type="text"
                    name="fees"
                    className="form-control"
                    required
                    defaultValue={data?.data?.final_fee || ""}
                  />

                  <label>Total Fee (₹)</label>

                  <span className="text-danger small">
                    {error?.final_fees ?? ""}
                  </span>
                </div>

                <div className="mt-4 form-floating form-floating-outline">
                  <textarea
                    name="discount_remark"
                    className="form-control input-uppercase hostel-remark-textarea"
                    required
                  />

                  <label>Discount Remark</label>

                  <span className="text-danger small">
                    {error?.discount_remark ?? ""}
                  </span>
                </div>
              </Modal.Body>

              <Modal.Footer className="hostel-modal-footer">
                <Button
                  variant="light"
                  size="sm"
                  onClick={() => setModalData(null)}
                >
                  Cancel
                </Button>

                <Button
                  type="submit"
                  variant="primary"
                  size="sm"
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>{" "}
                      Submitting...
                    </>
                  ) : (
                    <>
                      <i className="ri-save-line me-1"></i>
                      Save Changes
                    </>
                  )}
                </Button>
              </Modal.Footer>
            </form>
          </Modal>
        )}

        {/* =========================================================
            DISCOUNT REMARK MODAL
        ========================================================== */}

        <div className="modal fade" id="remarkModal" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content hostel-remark-modal">
              <div className="modal-header">
                <div className="d-flex align-items-center gap-2">
                  <div className="remark-modal-icon">
                    <i className="ri-chat-3-fill"></i>
                  </div>

                  <h5 className="modal-title mb-0">Discount Remark</h5>
                </div>

                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                ></button>
              </div>

              <div className="modal-body">
                <div className="remark-content">
                  {remark || "No remark available."}
                </div>
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-sm btn-light"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* =========================================================
            UI ONLY
        ========================================================== */}

        <style>{`

          /* =====================================================
             MAIN CARD
          ====================================================== */

          .course-fee-tab {
            width: 100%;
          }

          .hostel-record-card {
            border: 1px solid rgba(127, 127, 127, .12);
            border-radius: 12px;
            overflow: hidden;
          }


          /* =====================================================
             HEADER
          ====================================================== */

          .hostel-record-header {
            display: flex;
            align-items: center;
            justify-content: space-between;

            gap: 15px;

            padding: 14px 18px;

            background: transparent;

            border-bottom: 1px solid var(--bs-border-color);
          }

          .hostel-section-icon {
            width: 36px;
            height: 36px;

            display: flex;
            align-items: center;
            justify-content: center;

            border-radius: 9px;

            background: rgba(
              var(--bs-primary-rgb),
              .10
            );

            color: var(--bs-primary);

            font-size: 19px;
          }

          .hostel-record-header h5 {
            font-size: 15px;
            font-weight: 600;
          }

          .hostel-record-header p {
            font-size: 11px;
          }


          /* =====================================================
             TOTAL RECORDS
          ====================================================== */

          .fee-record-total {
            display: flex;
            flex-direction: column;
            align-items: flex-end;
          }

          .fee-record-total span {
            font-size: 9px;

            color: var(--bs-secondary-color);

            text-transform: uppercase;

            letter-spacing: .4px;
          }

          .fee-record-total strong {
            font-size: 14px;

            line-height: 1.2;

            color: var(--bs-primary);
          }


          /* =====================================================
             TABLE
          ====================================================== */

          .hostel-table-wrapper {
            border: 1px solid var(--bs-border-color);

            border-radius: 9px;

            overflow-x: auto;
          }

          .hostel-fee-table {
            min-width: 850px;

            margin: 0;
          }

          .hostel-fee-table thead th {
            padding: 10px 12px;

            background: rgba(
              127,
              127,
              127,
              .045
            );

            border-bottom: 1px solid
              var(--bs-border-color);

            color: var(--bs-secondary-color);

            font-size: 10px;

            font-weight: 700;

            text-transform: uppercase;

            letter-spacing: .45px;

            white-space: nowrap;
          }

          .hostel-fee-table tbody td {
            padding: 12px;

            border-bottom: 1px solid
              var(--bs-border-color);

            font-size: 12px;

            vertical-align: middle;
          }

          .hostel-fee-table tbody tr:last-child td {
            border-bottom: 0;
          }

          .hostel-fee-table tbody tr {
            transition:
              background .15s ease;
          }

          .hostel-fee-table tbody tr:hover {
            background:
              rgba(127,127,127,.035);
          }


          /* =====================================================
             ROW NUMBER
          ====================================================== */

          .hostel-row-number {
            width: 27px;
            height: 27px;

            display: inline-flex;
            align-items: center;
            justify-content: center;

            border-radius: 7px;

            background:
              rgba(127,127,127,.08);

            font-size: 11px;

            font-weight: 600;
          }


          /* =====================================================
             MONTH
          ====================================================== */

          .month-info {
            display: flex;
            align-items: center;

            gap: 9px;
          }

          .month-icon {
            width: 34px;
            height: 34px;

            min-width: 34px;

            display: flex;
            align-items: center;
            justify-content: center;

            border-radius: 8px;

            background:
              rgba(
                var(--bs-primary-rgb),
                .10
              );

            color: var(--bs-primary);

            font-size: 17px;
          }

          .month-title {
            display: block;

            font-size: 12px;

            font-weight: 600;
          }


          /* =====================================================
             AMOUNTS
          ====================================================== */

          .amount-text {
            font-weight: 500;

            white-space: nowrap;
          }

          .final-fee-cell {
            display: flex;
            align-items: center;

            gap: 5px;

            white-space: nowrap;
          }

          .final-fee-amount {
            color: var(--bs-success);

            font-weight: 700;
          }


          /* =====================================================
             INLINE EDIT / REMARK
          ====================================================== */

          .fee-inline-actions {
            display: inline-flex;

            align-items: center;

            gap: 2px;
          }

          .fee-icon-btn {
            width: 27px;
            height: 27px;

            padding: 0;

            border: 0;

            background: transparent;

            border-radius: 6px;

            display: inline-flex;

            align-items: center;

            justify-content: center;

            transition: all .15s ease;

            font-size: 14px;
          }

          .fee-icon-btn.edit {
            color: var(--bs-info);
          }

          .fee-icon-btn.remark {
            color: var(--bs-primary);
          }

          .fee-icon-btn:hover {
            background:
              rgba(127,127,127,.10);
          }


          /* =====================================================
             PAID
          ====================================================== */

          .paid-amount {
            color: var(--bs-success);

            font-weight: 600;

            white-space: nowrap;
          }


          /* =====================================================
             REMAINING
          ====================================================== */

          .remaining-fee {
            display: inline-flex;

            align-items: center;

            gap: 6px;

            color: var(--bs-danger);

            font-weight: 600;

            white-space: nowrap;
          }

          .remaining-dot {
            width: 6px;
            height: 6px;

            border-radius: 50%;

            background: currentColor;
          }

          .paid-status {
            display: inline-flex;

            align-items: center;

            gap: 5px;

            color: var(--bs-success);

            font-weight: 600;

            white-space: nowrap;
          }


          /* =====================================================
             ACTION GROUP
          ====================================================== */

          .fee-action-group {
            display: flex;

            align-items: center;

            justify-content: center;

            gap: 6px;

            white-space: nowrap;
          }


          /* =====================================================
             PAY BUTTON
          ====================================================== */

          .fee-pay-btn {
            min-width: 68px;

            padding: 6px 11px;

            border-radius: 7px;

            font-size: 12px;

            font-weight: 500;
          }


          /* =====================================================
             DELETE BUTTON
             IMPORTANT: Using Remix Icon instead of Bootstrap Icon
             so the icon is visible with your existing icon setup.
          ====================================================== */

          .fee-delete-btn {
            width: 34px;
            height: 34px;

            padding: 0;

            border: 1px solid
              rgba(
                var(--bs-danger-rgb),
                .12
              );

            border-radius: 7px;

            display: inline-flex;

            align-items: center;

            justify-content: center;

            background:
              rgba(
                var(--bs-danger-rgb),
                .08
              );

            color: var(--bs-danger);

            cursor: pointer;

            transition:
              background .15s ease,
              color .15s ease,
              border-color .15s ease;
          }

          .fee-delete-btn i {
            font-size: 16px;

            line-height: 1;

            color: currentColor;
          }

          .fee-delete-btn:hover {
            background: var(--bs-danger);

            border-color: var(--bs-danger);

            color: #fff;
          }


          /* =====================================================
             PAID ACTION
          ====================================================== */

          .paid-action {
            display: inline-flex;

            align-items: center;

            gap: 5px;

            padding: 6px 10px;

            border-radius: 7px;

            background:
              rgba(
                var(--bs-success-rgb),
                .10
              );

            color: var(--bs-success);

            font-size: 11px;

            font-weight: 600;
          }


          /* =====================================================
             EMPTY STATE
          ====================================================== */

          .empty-fee-state {
            text-align: center;

            padding: 40px 20px;
          }

          .empty-fee-icon {
            width: 48px;
            height: 48px;

            margin: 0 auto 10px;

            display: flex;

            align-items: center;

            justify-content: center;

            border-radius: 50%;

            background:
              rgba(127,127,127,.08);

            color:
              var(--bs-secondary-color);

            font-size: 23px;
          }

          .empty-fee-state h6 {
            font-size: 13px;

            margin-bottom: 3px;
          }

          .empty-fee-state p {
            margin: 0;

            color:
              var(--bs-secondary-color);

            font-size: 11px;
          }


          /* =====================================================
             MODALS
          ====================================================== */

          .hostel-modal-header {
            padding: 15px 18px;
          }

          .hostel-modal-header .modal-title {
            font-size: 16px;

            font-weight: 600;
          }

          .hostel-modal-alert {
            display: flex;

            gap: 11px;

            padding: 12px 14px;

            border-radius: 9px;

            background:
              rgba(
                var(--bs-info-rgb),
                .08
              );

            border: 1px solid
              rgba(
                var(--bs-info-rgb),
                .15
              );
          }

          .hostel-modal-alert-icon {
            width: 30px;
            height: 30px;

            min-width: 30px;

            display: flex;

            align-items: center;

            justify-content: center;

            border-radius: 7px;

            background:
              rgba(
                var(--bs-info-rgb),
                .12
              );

            color: var(--bs-info);
          }

          .hostel-modal-alert strong {
            display: block;

            font-size: 12px;

            margin-bottom: 2px;
          }

          .hostel-modal-alert p {
            font-size: 11px;

            line-height: 1.5;
          }

          .hostel-modal-info-box {
            padding: 12px 14px;

            border-radius: 8px;

            background:
              rgba(127,127,127,.055);

            border: 1px solid
              var(--bs-border-color);
          }

          .hostel-modal-info-box span {
            display: block;

            font-size: 10px;

            color:
              var(--bs-secondary-color);

            text-transform: uppercase;

            letter-spacing: .3px;
          }

          .hostel-modal-info-box strong {
            display: block;

            margin-top: 3px;

            font-size: 15px;
          }

          .hostel-current-fee-box {
            display: flex;

            align-items: center;

            gap: 20px;

            padding: 13px 15px;

            border-radius: 9px;

            background:
              rgba(
                var(--bs-primary-rgb),
                .055
              );

            border: 1px solid
              rgba(
                var(--bs-primary-rgb),
                .10
              );
          }

          .hostel-current-fee-box > div {
            display: flex;

            flex-direction: column;
          }

          .hostel-current-fee-box span {
            font-size: 10px;

            color:
              var(--bs-secondary-color);

            text-transform: uppercase;
          }

          .hostel-current-fee-box strong {
            font-size: 15px;

            margin-top: 2px;
          }

          .hostel-current-fee-box > i {
            color:
              var(--bs-secondary-color);
          }

          .hostel-remark-textarea {
            min-height: 100px !important;

            resize: vertical;
          }

          .hostel-modal-footer {
            border-top: 1px solid
              var(--bs-border-color);
          }


          /* =====================================================
             REMARK MODAL
          ====================================================== */

          .hostel-remark-modal {
            border-radius: 12px;

            overflow: hidden;
          }

          .remark-modal-icon {
            width: 34px;
            height: 34px;

            display: flex;

            align-items: center;

            justify-content: center;

            border-radius: 8px;

            background:
              rgba(
                var(--bs-primary-rgb),
                .10
              );

            color:
              var(--bs-primary);
          }

          .remark-content {
            padding: 14px;

            border-radius: 8px;

            background:
              rgba(127,127,127,.06);

            border: 1px solid
              var(--bs-border-color);

            font-size: 13px;

            line-height: 1.6;

            white-space: pre-wrap;
          }


          /* =====================================================
             MOBILE
          ====================================================== */

          @media (max-width: 767.98px) {

            .hostel-record-header {
              align-items: flex-start;

              flex-direction: column;
            }

            .fee-record-total {
              align-items: flex-start;
            }

            .hostel-fee-table {
              min-width: 850px;
            }

          }

        `}</style>
      </div>
    </>
  );
};

export default CourseNFeeTab;
